
/**
 * Props interface for PageLoading component
 * Single source of truth for component API
 */
interface PageLoadingProps {
  /** Loading message to display (default: 'Loading...') */
  message?: string;
}

/**
 * PageLoading - Page loading state component
 *
 * @component
 * @level template-part
 * @description Displays a centered loading spinner with optional message.
 * Used by DashboardLayout during data fetching.
 *
 * @example
 * ```tsx
 * <PageLoading message="Fetching your data..." />
 * ```
 */
export function PageLoading(props: PageLoadingProps) {
  // ONLY rendering logic, NO business logic
  const { message = 'Loading...' } = props;
  return (
    <div className="min-h-[400px] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 mb-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
        <p className="text-gray-600 text-sm">{message}</p>
      </div>
    </div>
  );
}